// Per-circuit landing-page content (bold intro line + logo), keyed by the
// lowercased circuit name. Add an entry here once you've verified a circuit's
// landing page and want it to read like a branded page instead of a filtered list.
export const CIRCUIT_PAGES = {
    "prep girls hoops": {
        intro: "The home of Prep Girls Hoops on TravelSports — every tournament, showcase, team and event in one place. Find it, add it, share it.",
        logo: "/circuits/prepgirlshoops.png",
    },
};

export function circuitPageMeta(name) {
    return CIRCUIT_PAGES[String(name || "").trim().toLowerCase()] || null;
}
